<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title>Login form</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form">
                  <v-text-field
                    v-model="email"
                    name="email"
                    label="Your Email"
                    type="email"
                    placeholder="Enter Your Email"
                    required
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="Enter Password"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>

                  <div class="red--text">{{ error }}</div>
                  <v-btn
                    dark
                    color="teal"
                    class="mr-4"
                    rounded
                    :loading="loading"
                    @click="submit()"
                  >
                    Login
                  </v-btn>
                  <v-btn to="/login/forgotpassword" sm text>
                    Forgot Password
                  </v-btn>
                  <!-- <router-link to="/login/forgotpassword">
                    Fogot Password
                  </router-link> -->
                </form>
              </v-card-text>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import api from "@/api";
// import ranges from "./ranges.json";
import axios from "axios";

export default {
  name: "LoginForm",
  data: () => ({
    valid: true,
    email: "",
    password: "",
    message: "",
    error: "",
    loading: false,
    rules: {
      required: (v) => !!v || "Field is required",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    },
    balancedCellSummary: [],
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          if (this.email && this.password) {
            // console.log(this.email , this.password);
            this.loading = true;
            const data = {email: this.email, password: this.password}
            await axios
              .post("/api/login", data)
              .then((res) => {
                // console.log(res);
                //   console.log(res.data.access_token);
                if (res.data) {
                  //   localStorage.setItem("token", res.data.access_token);
                  this.$cookies.set("token", res.data.access_token);
                  this.error = "";
                  this.message = "Login Success";
                  this.loading = false;
                  this.email = "";
                  this.password = "";
                  this.$router.push("/");
                  //    router.push({ name: "/" });
                }
              });
            // await api.login(form);
          }
        } catch (error) {
          this.email = "";
          this.password = "";
          this.loading = false;
          this.error = "Please Write Correct Details.";
        }
      }
    },
  },
};
</script>